/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import type { ReviewsSorting } from './interface';
import environmentConfig from '@/config/environment';

export const REVIEWS_DEFAULT_SORTING: ReviewsSorting = 'descendingStar';

export const BV_BASE_URL = environmentConfig.BV_BASE_URL;

export const BV_MEDIA_BASE_URL = environmentConfig.BV_MEDIA_BASE_URL;

export const BV_PASS_KEY = environmentConfig.BV_API_KEY;

export const BV_AUTH_CALLBACK_URL =
  environmentConfig.BV_AUTH_CALLBACK_URL ||
  'https://display.ugc.bazaarvoice.com/static/autozone/mobile_site/en_US/container.htm';

//Identifies the page from which the Create Review request is being sent
export const REVIEWS_PAGE_CAMPAIGN_ID = 'SEO_REVIEWS_PAGE_TYPE';

export const PDP_CAMPAIGN_ID = 'SITE_PRODUCT_DETAIL_PAGE';

export const ORDER_DETAILS_CAMPAIGN_ID = 'SITE_ORDER_DETAILS';

export const ORDER_HISTORY_CAMPAIGN_ID = 'SITE_ORDER_HISTORY';

export const RATE_AND_REVIEW_CAMPAIGN_ID = 'SITE_RATE_AND_REVIEW_PAGE';

export const HOME_PAGE_CAMPAIGN_ID = 'SITE_HOME_PAGE';

export const ACCOUNT_PAGE_CAMPAIGN_ID = 'SITE_ACCOUNT_PAGE';

export const EMAIL_RATE_AND_REVIEW_CAMPAIGN_ID = 'BV_PIE_SITE_RATE_AND_REVIEW_PAGE';

export const EMAIL_FOLLOWUP_RATE_AND_REVIEW_CAMPAIGN_ID =
  'BV_PIE_FOLLOWUP_SITE_RATE_AND_REVIEW_PAGE';

/**
 * Minimum total reviews before we show the Product Reviews Page
 */
export const MIN_PRP_REVIEW_COUNT = 10;

export const ADDITIONAL_FIELD_VEHICLE = 'additionalfield_Vehicle' as const;

export const ADDITIONAL_FIELD_VEHICLE_YEAR = 'additionalfield_Vehicle_Year' as const;

export const ADDITIONAL_FIELD_VEHICLE_MAKE = 'additionalfield_Vehicle_Make' as const;

export const ADDITIONAL_FIELD_VEHICLE_MODEL = 'additionalfield_Vehicle_Model' as const;

export const ADDITIONAL_FIELD_VEHICLE_SUBMODEL = 'additionalfield_Vehicle_SubModel' as const;

export const ADDITIONAL_FIELD_VEHICLE_ENGINE = 'additionalfield_Vehicle_Engine' as const;

export const VIDEO_EXTENSIONS = [
  '.3gp',
  '.3g2',
  '.asf',
  '.avi',
  '.dv',
  '.flv',
  '.mov',
  '.mp4',
  '.f4v',
  '.mpeg',
  '.mpg',
  '.qt',
  '.wmv',
];
